// event.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private eventSource = new Subject<any>();
  public event$ = this.eventSource.asObservable();

  triggerEvent(data: any): void {
    this.eventSource.next(data);
  }
}
